import { createContext } from 'react';
import { ClickAwayContextValue } from './types';

const notInitialized = () => {
    throw new Error('ClickAwayContext is not initialized');
};

const initialValue: ClickAwayContextValue = {
    registerClickAway: notInitialized,
    deregisterClickAway: notInitialized,
};

export const ClickAwayContext = createContext<ClickAwayContextValue>(initialValue);
